import { render, staticRenderFns } from "./IndustryTable.vue?vue&type=template&id=6fbcdd2a"
import script from "./IndustryTable.vue?vue&type=script&lang=js"
export * from "./IndustryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports